import { useAppRouter } from '@/common/route/useAppRouter';
import { timeUnits } from '@/common/utils/helpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';
import { useGameMatchList } from '@/modules/game/match/model/list';
import { duplicateService } from '@/services/duplicate';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useDuplicateItemDetail() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { fetchAllMatches, gameMatchCache } = useGameMatchList();

    const model = reactive({
        id: route.params.id,
        name: null,
        type: 0,
        matchId: '',
        matchName: '',
        cost: 0,
        prizes: '',
        round: 0,
        game: 1,
        timeUnit: 0,
        timeDuration: 0,
        prepareSeconds: 0,
        openSeconds: 0,
        closeSeconds: 0,
        rankingSeconds: 0,
        status: 0,
        publishTime: null,
        unpublishTime: null,
        nextStartTime: null,
        nextRankingTime: null,
        thumbnail: null,
        thumbnailFile: null,
        thumbnailStatus: null,
        canDelete: false
    });

    const fetch = crudAction.executeAction({
        request: () => duplicateService.item.get(model.id),
        onSuccess: ({ data }) => {
            data.matchName = gameMatchCache.value.get(data.matchId)?.label ?? '';
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_DUPLICATE.ITEM.INDEX })
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: () => duplicateService.item.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_DUPLICATE.ITEM.INDEX })
        })
    };

    onMounted(async () => {
        await fetchAllMatches();
        await fetch();
    });

    return { model, actions, timeUnits };
}
